<template>
  <div>
    <HeaderBack :title="$t('个人资料')" />
    <PersonalContent />
  </div>
</template>

<script>
import PersonalContent from '@/components/Personal/personalContent.vue';
import HeaderBack from '@/components/HeaderBack/index.vue';

export default {
  components: {
    PersonalContent,
    HeaderBack,
  },
  methods: {},
};
</script>

